import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { DataEnvironmentService } from 'src/app/services/data-environment/data-environment.service';
import {
    DATA_ENVIRONMENTS,
    DataEnvironment,
} from 'src/app/services/data-environment/models/data-environment.model';

@Component({
    selector: 'app-env-switcher',
    templateUrl: './env-switcher.component.html',
    styleUrls: ['./env-switcher.component.scss'],
})
export class EnvSwitcherComponent {
    env$: Observable<DataEnvironment> = this.dataEnv.env$;

    readonly envOptions = DATA_ENVIRONMENTS;

    constructor(private dataEnv: DataEnvironmentService) {}

    onEnvChange(env: DataEnvironment) {
        this.dataEnv.changeEnv(env, true);
    }
}
